export default __webpack_public_path__ + "static/media/Mockup-Head.38adbfab.png";